/**
 * BUNDLE DISCOUNT AUTOMATION
 * Automatically applies $2 discount when halter + lead are in cart together
 * This needs to be implemented on the backend or with a discount code
 */

(function() {
  'use strict';
  
  class BundleDiscount {
    constructor() {
      this.DISCOUNT_CODE = 'HALTER-LEAD-BUNDLE'; // Create this in Shopify admin
      this.DISCOUNT_AMOUNT = 2.00;
      this.init();
    }
    
    init() {
      // Check cart on page load
      this.checkForBundle();
      
      // Check again when cart updates
      document.addEventListener('cart:updated', () => {
        this.checkForBundle();
      });
    }
    
    async checkForBundle() {
      try {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        
        // Check if cart has both halter and lead
        const hasHalter = cart.items.some(item => 
          item.title.toLowerCase().includes('halter') && 
          !item.title.toLowerCase().includes('lead')
        );
        
        const hasLead = cart.items.some(item => 
          item.title.toLowerCase().includes('lead') && 
          !item.title.toLowerCase().includes('halter')
        );
        
        if (hasHalter && hasLead) {
          this.applyBundleDiscount();
        }
      } catch (err) {
        console.error('Error checking bundle:', err);
      }
    }
    
    applyBundleDiscount() {
      // Show bundle applied message
      this.showBundleMessage();
      
      // If on cart page, try to apply discount code
      if (window.location.pathname === '/cart') {
        this.applyDiscountCode();
      }
    }
    
    showBundleMessage() {
      // Don't show if already displayed
      if (document.querySelector('.bundle-applied-message')) return;
      
      const message = document.createElement('div');
      message.className = 'bundle-applied-message';
      message.innerHTML = `
        <div class="bundle-message-content">
          <span class="bundle-check">✓</span>
          <div>
            <strong>Bundle Discount Applied!</strong>
            <p>You saved $2 on your halter & lead set</p>
          </div>
        </div>
      `;
      
      // Add to cart form or notification area
      const cartForm = document.querySelector('.cart-items, .cart__items');
      if (cartForm) {
        cartForm.insertBefore(message, cartForm.firstChild);
      }
    }
    
    async applyDiscountCode() {
      const discountInput = document.querySelector('[name="discount"]');
      if (discountInput && !discountInput.value) {
        discountInput.value = this.DISCOUNT_CODE;
        
        // Try to submit the discount form
        const discountForm = discountInput.closest('form');
        if (discountForm) {
          // Simulate form submission
          const submitBtn = discountForm.querySelector('[type="submit"]');
          if (submitBtn) submitBtn.click();
        }
      }
    }
  }
  
  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new BundleDiscount();
    });
  } else {
    new BundleDiscount();
  }
  
})();

/* Bundle message styling */
const style = document.createElement('style');
style.textContent = `
  .bundle-applied-message {
    background: linear-gradient(135deg, #E8F5E8, #D4E6D4);
    border: 2px solid #4A7C59;
    border-radius: 12px;
    padding: 15px;
    margin: 20px 0;
    animation: slideDown 0.5s ease;
  }
  
  .bundle-message-content {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  
  .bundle-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #4A7C59;
    color: white;
    border-radius: 50%;
    font-size: 24px;
    font-weight: bold;
  }
  
  .bundle-applied-message strong {
    color: #3B3227;
    font-size: 16px;
    display: block;
    margin-bottom: 4px;
  }
  
  .bundle-applied-message p {
    color: #666;
    font-size: 14px;
    margin: 0;
  }
`;
document.head.appendChild(style);